type CallbackFn = () => void;

let callback: CallbackFn | undefined;
let showModal: (() => void) | undefined;
let hideModal: (() => void) | undefined;
let setText: ((text?: string) => void) | undefined;

export const BuilderAlertManager = {
  open(cb: CallbackFn, type?: string) {
    callback = cb;
    setText?.(type);
    showModal?.();
  },
  confirm() {
    if (callback) {
      callback();
      callback = undefined;
    }
    hideModal?.();
  },
  cancel() {
    callback = undefined;
    hideModal?.();
  },
  // Called from the modal component
  registerModal(
    setShow: () => void,
    setHide: () => void,
    setTextFn?: (text?: string) => void
  ) {
    showModal = setShow;
    hideModal = setHide;
    if (setTextFn) setText = setTextFn;
  },
};
